export default "__VITE_ASSET__BQfRJCs___"